import { RouteObject } from '../routes/router';

const flattenRoutes = (routesObject: RouteObject[]): Omit<RouteObject, 'routes'>[] =>
  routesObject.reduce((result, { routes: subRoutes, ...route }) => {
    return [
      ...result,
      route,
      ...(subRoutes
        ? flattenRoutes(
            subRoutes.map((subRoute) => ({
              ...subRoute,
              path: `${route.path}${subRoute.path}`,
            })),
          )
        : []),
    ];
  }, [] as Omit<RouteObject, 'routes'>[]);

export default flattenRoutes;
